import { useTranslation } from "react-i18next";

// Compact language switcher — persists the choice via i18next language
// detector (localStorage key "revgrow.lang").
export default function LanguageSwitcher({ variant = "header" }) {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "en").slice(0, 2);

  const langs = [
    { code: "en", label: "EN" },
    { code: "de", label: "DE" },
  ];

  const change = (code) => {
    if (code !== current) i18n.changeLanguage(code);
  };

  const base =
    variant === "header"
      ? "inline-flex items-center rounded-full border border-white/15 p-0.5 text-[11px] uppercase tracking-widest2"
      : "inline-flex items-center gap-2 text-[11px] uppercase tracking-widest2";

  return (
    <div className={base} data-testid="language-switcher" role="group" aria-label="Language">
      {langs.map((l) => {
        const active = l.code === current;
        return (
          <button
            key={l.code}
            onClick={() => change(l.code)}
            aria-pressed={active}
            data-testid={`lang-${l.code}`}
            className={`px-2.5 py-1 rounded-full transition-colors ${
              active
                ? "bg-clay-500 text-bone-100"
                : "text-bone-100/70 hover:text-clay-400"
            }`}
          >
            {l.label}
          </button>
        );
      })}
    </div>
  );
}
